/**
 * Accessibility patches for third-party widgets the theme can't edit:
 * - the HubSpot chat launcher's drag-handle icon has no text alternative, so it's hidden from assistive tech
 *   (the handle keeps its "Drag" title);
 * - reCAPTCHA (in HubSpot forms) adds a hidden, unlabeled response textarea, so it gets a label and stays hidden.
 * Widgets load late, so a MutationObserver applies the patch whenever they appear.
 */
(() => {
  const patch = () => {
    document.querySelectorAll('.hs-drag-handle svg:not([aria-hidden])').forEach((svg) => {
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });
    document.querySelectorAll('textarea.g-recaptcha-response:not([aria-label])').forEach((field) => {
      field.setAttribute('aria-label', 'reCAPTCHA response');
      field.setAttribute('aria-hidden', 'true');
    });
  };
  patch();
  new MutationObserver(patch).observe(document.documentElement, { childList: true, subtree: true });
})();
